import React from "react";
import PropTypes from "prop-types";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

class ThumbnailView extends React.Component {
  constructor() {
    super();
    this.state = {
      images: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      JSON.stringify(nextProps.images) !== JSON.stringify(this.state.images)
    ) {
      this.setState({
        images: nextProps.images,
      });
    }
  }

  render() {
    const { onClickItem } = this.props;
    const { images } = this.state;
    return (
      <Carousel showArrows={true} onClickItem={onClickItem}>
        {images.map((item, key) => {
          return (
            <div key={key}>
              <img
                src={
                  item.media_type === "image" ? item.media_file : item.thumbnail
                }
              />
            </div>
          );
        })}
      </Carousel>
    );
  }
}

ThumbnailView.defaultProps = {
  images: [],
};

ThumbnailView.propTypes = {
  images: PropTypes.array,
  onClickItem: PropTypes.func,
};

export default ThumbnailView;



// WEBPACK FOOTER //
// ./client/react/Admin/components/ThumbnailView/index.jsx